// extracted by mini-css-extract-plugin
export default {"item-title":"Item_item-title__ZJxyR","item-title__text":"Item_item-title__text__rG+ng","line-sep":"Item_line-sep__5eyeU"};